<template>
  <div class="error-page">
    <div class="error-page-top-image">
      <img
        src="../assets/img/top-image.png"
        alt="404"
      >
    </div>
    <div class="error-page-text">
      <h1>Oops!</h1>
      <p>{{ $t('error-page.can-not-find-page') }}</p>
    </div>
    <div class="error-page-bottom-image">
      <img
        src="../assets/img/bottom-image.png"
        alt="404"
      >
    </div>
    <div class="error-page-back-btn-wrapper">
      <router-link
        :to="{name: 'SignIn'}"
        custom
        v-slot="{ navigate }"
        class="error-page-back-btn"
      >
        <el-button
          type="primary"
          class="primary-button"
          @click="navigate"
        >
          {{ $t('form.back-to-home') }}
        </el-button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage'
};
</script>

<style lang="scss" scoped>
.error-page {
  height: 100%;
  background: url('../assets/img/404-background.svg') no-repeat;
  background-size: cover;

  &-top-image {
    padding-top: 60px;
    text-align: right;

    img {
      width: 100%;
      max-width: 333px;
      height: 133px;
    }
  }

  &-bottom-image {
    margin-top: 85px;
    text-align: center;

    img {
      width: 257px;
      height: 291px;
    }
  }

  &-text {
    margin-top: 50px;
    text-align: center;
    padding: 10px 22px;

    h1 {
      font-size: 32px;
      font-family: "Raleway Bold", serif;
      margin-bottom: 12px;
      color: #2D2E2F;
    }

    p {
      font-size: 16px;
      line-height: 24px;
      font-family: "Raleway Regular", serif;
      color: #2D2E2F;
      margin: 0;
    }
  }

  &-back-btn {
    &-wrapper {
      padding: 8px 12px;
    }
  }
}
</style>
